import React from 'react';
import { Chart } from 'primereact/chart';

import { bdi_type } from './AtributosBDI';

const ChartBDI = props => {
    return React.createElement(Chart, { type: props.tipo, data: props.dados });
};

ChartBDI.bdi_type = bdi_type;

export default ChartBDI;